import { useState, useEffect, FunctionComponent, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Switch, Dialog } from '../../tailwindcomponents';
import { Typography, Input, Select } from '../../tailwindcomponents';
import { Dictionary } from '../../components';
import { RootState } from '../../reducer';
import UserApi from '../../api/userApi';
import SubcontractsApi from './../../api/subContracts';
import { dictionary } from '../../types/general';
import { User } from './../../types/user';

type CertificateProps = {
    setLoading: Function
}

// Basic dictionary page using the dictionary component so easy to change style of all dictionary pages if needed.
const EditSubcontracts: FunctionComponent<CertificateProps> = ({ setLoading }) => {
    const dispatch = useDispatch();
    const [subContracts, setSubContracts] = useState(Array<User>());
    const [newEmployeeName, setNewEmployeeName] = useState("");
    const [newSSN, setNewSSN] = useState('');
    const [newEmployeeNumber, setNewEmployeeNumber] = useState('');
    const [newJobTitle, setNewJobTitle] = useState("");
    const [newDepartment, setNewDepartment] = useState("");
    const [selectedUser, setSelectedUser] = useState<User>();
    const store = useSelector((state: RootState) => state);
    const [showActive, setShowActive] = useState(true);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteReason, setDeleteReason] = useState('');
    const [allCompanies, setAllCompanies] = useState(Array<dictionary>());
    const [selectedCompany, setSelectedCompany] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const refresh = () => {
        setLoading(true);
        setDeleteDialogOpen(false);
        UserApi.getAllUsers().then(res => {
            const subContracts = res.filter(s => s.company_name !== "Icelandair");
            setSubContracts(subContracts);
            dispatch({ type: "GET_ALL_EMPLOYEES", all_employees: res });
            setLoading(false);
        })
        SubcontractsApi.GetAllCompanies().then(res => {
            if (res.status === true) {
                setAllCompanies(res.data.filter(s => s.visible));
            }
        })
    }

    const addSubContractor = () => {
        const companyId = allCompanies.find(s => s.name === selectedCompany)!.id;
        SubcontractsApi.AddNewSubContract(newEmployeeName, newJobTitle, newDepartment, newSSN, newEmployeeNumber, companyId, store.user.me.user_id).then(res => {
            if (res.status === true) {
                refresh();
                setNewDepartment("");
                setNewEmployeeName("");
                setNewEmployeeNumber("");
                setNewJobTitle("");
                setNewSSN("");
                setSelectedCompany("");
                setErrorMessage("");
            } else {
                setErrorMessage(res.message);
            }
        })
    }
    const confirmDelete = () => {
        selectedUser!.deleted_reason = deleteReason;
        SubcontractsApi.DeleteSubContract(selectedUser!).then(res => {
            refresh();
        })
    }
    const onDeleteSubContract = (user: User) => {
        setDeleteDialogOpen(true);
        setSelectedUser(user);
    }
    const returnStringArray = (data: Array<dictionary>) => {
        const temp: Array<string> = data.map(el => el.name);
        return temp;
    }
    return (
        <div>
            <div className="flex flex-wrap items-start justify-center w-full" >
                <div className="w-1/2">
                    <div className="flex flex-wrap w-full">
                        <div className="w-1/3 lg:w-2/3"></div>
                        <div className="w-1/6 lg:w-1/12">
                            <Typography text="Active" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
                        </div>
                        <div className="w-1/6 lg:w-1/12">
                            <Switch
                                checked={!showActive}
                                onChange={() => setShowActive(!showActive)}
                                color="secondary"
                                name="checkedB"
                            />
                        </div>
                        <div className="w-1/6 lg:w-1/12">
                            <Typography text="Deleted" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
                        </div>
                    </div>
                </div>
                <div className="flex flex-wrap">
                    <div className="w-7/12">
                        {
                            subContracts.filter(type => type.visible === showActive).map(row => (
                                <Dictionary name={row.name} object={row} deleted={showActive === true ? false : true} description={showActive === true ? row.company_name : row.deleted_reason} id={row.Id} deleteProperty={(user: User) => onDeleteSubContract(user)}></Dictionary>
                            ))
                        }
                    </div>
                    <div className="flex flex-wrap w-5/12">
                        <div className="w-full">
                            <br />
                            <Input
                                multiline={false}
                                label_text="Name"
                                help_text="Please type in a name for the new employee"
                                type="text"
                                value={newEmployeeName}
                                width={50}
                                onTextChange={(value: string) => setNewEmployeeName(value)}
                            />
                        </div>
                        <div className="w-full">
                            <br />
                            <Input
                                multiline={false}
                                label_text="Job title"
                                help_text="Please type in a job title for the new employee"
                                type="text"
                                value={newJobTitle}
                                width={50}
                                onTextChange={(value: string) => setNewJobTitle(value)}
                            />
                        </div>
                        <div className="w-full">
                            <br />
                            <Select onSelectedItem={(e: any) => setNewDepartment(e.target.value)} selectedItem={newDepartment} width={300} filter_by_text={"Department"} options={["Base Maintenance", "Shops", "Other"]} />
                        </div>
                        <div className="w-full">
                            <br />
                            <Input
                                multiline={false}
                                label_text="Social security number"
                                help_text="Please type in a social security number for the new employee"
                                type="text"
                                value={newSSN}
                                width={50}
                                onTextChange={(value: string) => setNewSSN(value)}
                            />
                        </div>
                        <div className="w-full">
                            <br />
                            <Input
                                multiline={false}
                                label_text="Employee Hr number"
                                help_text="Please type in a Hr number for the new employee"
                                type="text"
                                value={newEmployeeNumber}
                                width={50}
                                onTextChange={(value: string) => setNewEmployeeNumber(value)}
                            />
                        </div>
                        <div className="w-full">
                            <br />
                            <Select onSelectedItem={(e: any) => setSelectedCompany(e.target.value)} selectedItem={selectedCompany} width={200} filter_by_text={"Choose companies"} options={returnStringArray(allCompanies)} />
                        </div>
                        <div>
                            <br />
                            <Button variant="contained" color="primary" className="bg-accent text-[color:var(--ds-accent-fg)] text-sm" onClick={() => addSubContractor()} >
                                Add Subcontract
                            </Button>
                            <Typography text={errorMessage} textColor='red' align='center' />
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                visible={deleteDialogOpen}
                max_width={"md"} title={"Are you sure you want to delete this?"}
                context={
                    <div>
                        <div className="flex justify-center w-full m-2 p-2">
                            <Input
                                label_text={"Type a reason"} value={deleteReason} help_text=""
                                onTextChange={(value: string) => setDeleteReason(value)} type="text" width={50} multiline={false} />
                        </div>

                        <div className="flex justify-center m-2 p-2">
                            <div className="p-2" >
                                <Button variant="contained" color="primary" onClick={() => confirmDelete()}>Confirm delete</Button>
                            </div>
                            <div className="p-2">
                                <Button variant="contained" color="secondary" onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                }
                onClose={(status: any) => setDeleteDialogOpen(false)}
                strict={false}
                show_options={false}
            />
        </div>
    );
};
export default EditSubcontracts;
